import React from 'react';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import HelpIcon from '@material-ui/icons/Help';
import IconButton from '@material-ui/core/IconButton';
import {theme} from './theme';
import useStyles from "./styles";
import PTSSignifier from './PTSSignifier';
import * as Constants from '../Constants';

export default function PTSHelp() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();                        

  // Hide/Display the Help Information
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
        <IconButton aria-describedby={id} className={classes.helpIcon}  onClick={handleClick}>
            <HelpIcon/>
        </IconButton>
        
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}    
        >
            <Box margin='1em'>
                <Typography variant="h6"> 
                    <Box fontWeight='fontWeightBold' display='inline'>Background</Box> 
                </Typography>

                <Typography component="div" >Check Test Results is generated by running the 
                    <Box fontWeight='fontWeightBold' display='inline'> ./phoronix-test-suite check-tests
                    </Box> command in the Phoronix Test Suite. 
                </Typography> 

                <Typography>Each Test Profile is iterated to extract a download.xml file. </Typography>
                <Typography>If a Test Profile does not contain a download.xml file the Test Profile is tagged as Not Tested.</Typography>
                <Typography>If a Test Profile does contains a download.xml file, the contents are examined to determine the validity of the file location, the download
                and MD5 and SHA256 checksums.</Typography>
                <br/>

                <Typography>If any errors are present the Error Type and Error Status

                    <Box fontWeight='fontWeightMedium' display='inline' style={{color:theme.palette.secondary.main}}> (red, </Box> 
                    <Box fontWeight='fontWeightMedium' display='inline' style={{color:theme.palette.warning.main}}> orange, </Box> 
                    <Box fontWeight='fontWeightMedium' display='inline' style={{color:theme.palette.pass.main}}> green) </Box> 
                    will be displayed against the Profile Name and against the Mirror where the error occurred. The 
                    <Box fontWeight='fontWeightBold' display='inline'> Legend Box </Box>
                    can be selected to display more details about the Type and Status of the error.
                </Typography>
                <br/>
                <Typography>
                    In some cases a Passed test may appear with an Error Type Signifier such as 
                    <Box fontWeight='fontWeightBold' style={{color:theme.palette.primary.main}} display='inline'> Test Profile</Box> 
                    <Box display="inline"><PTSSignifier  colorStatus={[Constants.COLOR_301]}/>. </Box>
                    This indicates that a mirror failed with a HTTP 301 Status, but other working mirrors are available. 
                </Typography>
                <br/>

                <Typography variant="h6"> 
                    <Box fontWeight='fontWeightBold' display='inline'>Navigating The Page</Box> 
                </Typography>

                <Typography component="div">To examine a Test Profile click on the 
                    <Box fontWeight='fontWeightBold' style={{color:theme.palette.primary.main}} display='inline'> Profile. </Box> 
                </Typography>

                <Typography>
                    Each <Box fontWeight='fontWeightBold' style={{color:theme.palette.primary.main}} display='inline'> Profile </Box>
                    may contain one or more clickable<Box fontWeight='fontWeightBold' style={{color:theme.palette.primary.main}} display='inline'> Packages. </Box>
                </Typography>

                <Typography>
                Each <Box fontWeight='fontWeightBold' style={{color:theme.palette.primary.main}} display='inline'> Package </Box>
                may contain one or more clickable <Box fontWeight='fontWeightBold' style={{color:theme.palette.primary.main}} display='inline'> Mirrors. </Box>
                </Typography>

                <Typography>
                    Click on the 
                    <Box fontWeight='fontWeightBold' style={{color:theme.palette.primary.main}} display='inline'> Mirror, </Box>
                    to see details about the Failures.
                </Typography>
                <br/>
                <Typography>
                    Hint: Any colored text can be clicked.
                </Typography>
                <br/>      
                <br/>

                <Typography component="div" variant="h6"> 
                    <Box fontWeight='fontWeightBold' display='inline'>Filters</Box> 
                </Typography>
                <Typography component="div">Tests can be filtered based on what you want to see.</Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> All Versions:</Box> Displays all the tests.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> Latest Versions:</Box> Displays the latest version for each Test Profile.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> Failed:</Box> Displays all tests that failed.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> Not Tested:</Box> Displays all tests which were not tested and therefore have no results.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> Checksum</Box> Displays all tests which have a failed checksum.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> Rediects:</Box> Displays all tests which resulted in a HTTP 301 or 302 status.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> Downloads:</Box> Displays all tests that produced an unsuccessful download.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> All:</Box> Displays all tests which had a failed Checksum, Redirect or Download.
                </Typography>     
                <br/>
                <br/>

                <Typography variant="h6"> 
                    <Box fontWeight='fontWeightBold' display='inline'>Explaination of Terms</Box> 
                </Typography>
                <Typography component="div" >Each Test Profile contains one or more 
                    <Box fontWeight='fontWeightBold' display='inline'> packages. </Box>
                    Each Package contains one or more 
                    <Box fontWeight='fontWeightBold' display='inline'> mirrors. </Box> 
                </Typography>
                <br/>

                <Typography component="div"> 
                    <Box fontWeight='fontWeightBold' display='inline'> Packages</Box> contain:
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> File Name:</Box> Name of the file downloaded from the vendor.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> File Size: </Box> Size of the file downloaded from the vendor.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> SHA256: </Box> SHA256 Key if provided. May be blank. 
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'> MD5: </Box> MD5 Key if provided. May be blank. 
                </Typography>
                <br/>

                <Typography component="div"> 
                    <Box fontWeight='fontWeightBold' display='inline'> Mirrors</Box> contain:
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>Status:</Box> The test passed or failed.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>Source: </Box> The test was identical to a previously downloaded test and was reused.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>URL: </Box> The location of the downloaded test. In most cases this will download the test. 
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>Download Time: </Box> The time taken in millisecs to download the test. 
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>Redirect To: </Box> URL used when HTTP 302 Redirect is encountered. 
                </Typography>
            
                <br/>
                <Typography component="div"> 
                    <Box fontWeight='fontWeightBold' display='inline'> Failures</Box> contain:
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>File Size:</Box> The file size downloaded does not match the package filesize.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>MD5: </Box> The MD5 checksum does not match the package MD5 checksum.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>SHA256: </Box> The SHA256 checksum does not match the package MD5 checksum. 
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>Vendor: </Box> Returned HTTP Status Code when attempting to download file.
                </Typography>
                <Typography component="div">
                    <Box ml={5} fontWeight='fontWeightBold' display='inline'>Timed Out: </Box> File failed to download due to a curl time out. Note, Time Out 
                    can be configured by setting the Download Rate when running the ./phoronix-test-suite check-tests command.
                </Typography> 
            </Box>
        </Popover> 
    </>
  );
}